<template>
    <!-- 填报意向 -->
    <div class="intention_box">
        <div class="userintente">
            <div class="userintentetitle"><i class="iconfont">&#xe7ce;</i> 填报意向</div>
            <div class="userintentebox">
                <div class="uibox">
                    <div class="uitip">批次：</div>
                    <el-select v-model="SubmitData.IntentionBatchId" placeholder="请选择" style="margin:20px 0 0 20px;" @change="BatchDataChange">
                        <el-option v-for="(item,index) in BatchData" :key="index" :label="item.BatchName" :value="item.BatchId"></el-option>
                    </el-select>
                    <div class="clear"></div>
                </div>
                <div class="uibox">
                    <div class="uitip">院校：</div>
                    <div class="sinputbox">
                        <el-input v-model="SearchCollegeName" id="College_Input_ID" placeholder="搜索院校" clearable style="width:100%" @keyup.enter.native="searchCollege()" @focus="focusCollegeSearch()" @clear="clearCollegeSearch()"></el-input>
                        <div v-show="ShowCollegeSearch" id="College_Show_ID" class="search-box">
                            <div class="search-li" v-for="SCItem in SearchCollegeData" :key="SCItem.Id" @click="SelectSearchItem(SCItem)">
                                <i v-show="SearchCollegeCheckList.find(i => i.Id === SCItem.Id)" class="selected-icon iconfont">&#xe68a;</i>
                                {{ SCItem.Name }}
                            </div>
                            <div class="no-data" v-if="SearchCollegeData.length <= 0">
                                <span>暂无数据</span>
                            </div>
                        </div>
                    </div>
                    <div class="s_btn" id="Search_Button_ID" @click.prevent="searchCollege()"><i class="el-icon-search"></i> 搜 索</div>
                    <div class="clear"></div>
                    <div v-if="SearchCollegeCheckList&&SearchCollegeCheckList.length>0" style="color:#666;font-size:12px;margin-left:120px;margin-bottom:5px;">提示：可拖动排序</div>
                    <div class="uiitem" id="WishSortTable1" :style="{'border':(SearchCollegeCheckList&&SearchCollegeCheckList.length>0)?'1px dashed #aaaaaa':'1px dashed #fff'}">
                        <span class="it" :id="item.Id" v-for="(item,index) in SearchCollegeCheckList" :key="index">{{item.Name}}<i class="close iconfont" @click.prevent="RemoveCollegeItem(item)">&#xe620;</i></span>
                    </div>
                </div>
                <div class="uibox">
                    <div class="uitip">专业：</div>
                    <div class="mjitem">
                        <div class="levbox" v-if="ProvinceObj.EnableRecommendEducationLevel">
                            <span class="item" :class="(MajorScreenSelectLevel ===1?'on':'')" @click.prevent="selectMajorLevel(1)">本科</span>
                            <span class="item" :class="(MajorScreenSelectLevel ===0?'on':'')" @click.prevent="selectMajorLevel(0)">专科</span>
                        </div>
                        <div class="mjbox">
                            <el-popover v-for="major in MajorTypeData" :key="major.Id" trigger="hover" :open-delay="50" @after-enter="ThreeMajorLayerShow(major.SubList[0].Id,major.SubList[0].SubList)" @hide="ThreeMajorLayerHide" placement="bottom" width="300" popper-class="search_major_popover">
                                <div class="search_majorbox" :style="MajorCheckListStyle">
                                    <el-scrollbar wrap-class="scrollbar-wrapper" :style="MajorCheckListStyle" style="width:50%;">
                                        <div class="citem" :class="MajorTypeCheckList.find(f=>f.Id==item1.Id)?'on':''" v-for="item1 in major.SubList" :key="item1.Id" @click.prevent="MajorTypeCheck(item1)" @mouseenter="ThreeMajorLayerShow(item1.Id,item1.SubList)">
                                            <i class="iconfont chck">&#xe68a;</i>
                                            <span class="mname" :class="MajorTypeHover==item1.Id?'on':''">{{item1.Name}}<span class="num" v-if="item1.CheckNumber">{{item1.CheckNumber}}</span></span>
                                            <i class="el-icon-arrow-right three" v-if="item1.SubList"></i>
                                        </div>
                                    </el-scrollbar>
                                    <div class="three_major_box" v-if="ThreeMajorShow">
                                        <el-scrollbar wrap-class="scrollbar-wrapper" :style="MajorCheckListStyle">
                                            <div class="citem" :class="MajorTypeCheckList.find(f=>f.Id==item3.Id)?'on':''" v-for="item3 in ThreeMajorData" :key="item3.Id" @click.prevent="MajorTypeCheck(item3)">
                                                <i class="iconfont chck">&#xe68a;</i>
                                                <span class="mname">{{item3.Name}}</span>
                                            </div>
                                        </el-scrollbar>
                                    </div>
                                </div>
                                <el-button slot="reference">{{major.Name}}<i class="el-icon-arrow-down"></i><span class="num" v-if="major.CheckNumber">{{major.CheckNumber}}</span></el-button>
                            </el-popover>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                    <div class="chbox">
                        <!-- <div class="check" @click.prevent="ContainMajorCheck(false)"><div class="ico" :class="SubmitData.IsMajorAcceptOnly==false?'on':''"><i class="iconfont">&#xe68a;</i></div>优先考虑以下专业<div class="clear"></div></div>
                        <div class="check" @click.prevent="ContainMajorCheck(true)"><div class="ico" :class="SubmitData.IsMajorAcceptOnly==true?'on':''"><i class="iconfont">&#xe68a;</i></div>只考虑以下专业<div class="clear"></div></div>
                        <div class="clear"></div> -->
                    </div>
                    <div class="clear"></div>
                    <div v-if="MajorTypeCheckList&&MajorTypeCheckList.length>0" style="color:#666;font-size:12px;margin-left:120px;margin-bottom:5px;">提示：可拖动排序</div>
                    <div class="uiitem" id="WishSortTable2" :style="{'border':(MajorTypeCheckList&&MajorTypeCheckList.length>0)?'1px dashed #aaaaaa':'1px dashed #fff'}">
                        <span class="it" :id="item.Id" v-for="(item,index) in MajorTypeCheckList" :key="index">{{item.Name}}<i class="close iconfont" @click.prevent="RemoveMajorItem(item)">&#xe620;</i></span>
                    </div>
                </div>
                <div class="uibox">
                    <div class="uitip">地区：</div>
                    <div class="mjitem">
                        <span class="area" :class="AreaDataCheck.find(f=>f.ProvinceId==area.ProvinceId)?'on':''" @click.prevent="AreaCheck(area)" v-for="(area,index) in AreaData" :key="index">{{area.ProvinceName}}</span>
                    </div>
                    <div class="clear"></div>
                    <div class="chbox"></div>
                    <div v-if="AreaDataCheck&&AreaDataCheck.length>0" style="color:#666;font-size:12px;margin-left:120px;margin-bottom:5px;">提示：可拖动排序</div>
                    <div class="uiitem" id="WishSortTable3" :style="{'border':(AreaDataCheck&&AreaDataCheck.length>0)?'1px dashed #aaaaaa':'1px dashed #fff'}">
                        <span class="it" :id="item.ProvinceId" v-for="(item,index) in AreaDataCheck" :key="index">{{item.ProvinceName}}<i class="close iconfont" @click.prevent="RemoveAreaItem(item)">&#xe620;</i></span>
                    </div>
                </div>
                <div class="uibox">
                    <div class="uitip">其他：</div>
                    <div class="other">
                        <span class="ot">
                            <span>非公办院校：</span>
                            <el-switch v-model="SubmitData.IsAcceptFeiGongBan" inactive-text="不接受" active-text="接受" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
                        </span>
                        <span class="ot">
                            <span>中外合作专业：</span>
                            <el-switch v-model="SubmitData.IsAcceptZhongWai" inactive-text="不接受" active-text="接受" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
                        </span>
                        <span class="ot">
                            <span>师范专业：</span>
                            <el-switch v-model="SubmitData.IsAcceptShiFan" inactive-text="不接受" active-text="接受" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
                        </span>
                        <span class="ot">
                            <span>定向/专项专业：</span>
                            <el-switch v-model="SubmitData.IsAcceptDingXiang" inactive-text="不接受" active-text="接受" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
                        </span>
                        <span class="ot">
                            <span>民族/预科：</span>
                            <el-switch v-model="SubmitData.IsAcceptNationa" inactive-text="不接受" active-text="接受" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
                        </span>
                        <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <div class="submitbtn" @click.prevent="SubmitIntention()">保 存</div>
    </div>
</template>
<script>
import API from "@/api/config";
import { deepClone } from '@/utils/index';
import { getStore } from "@/utils/utils";
import Sortable from 'sortablejs';
export default{
    data(){
        return {
            loading:false,
            ProvinceObj: {}, // 省份
            modifyFlag:false,
            BatchData:[],

            SearchCollegeName:'',
            SearchCollegeData:[],
            ShowCollegeSearch:false,
            SearchCollegeCheckList:[],

            MajorScreenSelectLevel:1,
            MajorCheckListStyle:'',
            MajorTypeData: [],// 专业基础数据
            MajorTypeCheckList:[],// 选择的专业
            ThreeMajorShow:false,// 三级专业
            ThreeMajorData:[],// 三级专业
            MajorTypeHover:'',

            AreaData:[],
            AreaDataCheck:[],

            SubmitData:{
                IntentionBatchId: null,
                IntentionBatchName: "",
                // IsMajorAcceptOnly: false,
                IsAcceptFeiGongBan: false,
                IsAcceptZhongWai: false,
                IsAcceptShiFan: false,
                IsAcceptDingXiang: false,
                IsAcceptNationa: false,
                IntentionCollegeList: [
                    // {
                    //     // AreaType: null,
                    //     // CollegeId: null,
                    //     // CollegeName: ""
                    // }
                ],
                IntentionMajorList: [
                    // {
                    //     // AreaType: null,
                    //     // MajorId: null,
                    //     // MajorName: "",
                    //     // EducationLevel: null
                    // }
                ],
                IntentionAreaList: [
                    // {
                    //     AreaType: null,
                    //     AreaId: null,
                    //     AreaName: ""
                    // }
                ]
            }
        }
    },
    mounted(){
        this.GetRecommend();
        setTimeout(() => {
            let Ele1 = document.getElementById('College_Input_ID')
            let Ele2 = document.getElementById('College_Show_ID')
            let Ele3 = document.getElementById('Search_Button_ID')
            const ClickHidden = (event) => {
                if (event.target !== Ele1 && event.target !== Ele2 && event.target !== Ele3 && !Ele2.contains(event.target)) {
                    this.ShowCollegeSearch = false
                }
            }
            document.removeEventListener('click', ClickHidden)
            document.addEventListener('click', ClickHidden)
        }, 50);
        // 院校拖动排序
        this.$nextTick(() => {
            let that = this;
            Sortable.create(document.getElementById('WishSortTable1'),{
                animation: 300,
                easing: "cubic-bezier(1, 0, 0, 1)", // 移动动画。默认为 null。例如 https://easings.net/。
                fallbackTolerance: 50, // 以像素为单位指定鼠标在被视为拖动之前应移动的距离
                swapThreshold: 50, // 交换区域的阈值
            });
        });
        // 专业拖动排序
        this.$nextTick(() => {
            let that = this;
            Sortable.create(document.getElementById('WishSortTable2'),{
                animation: 300,
                easing: "cubic-bezier(1, 0, 0, 1)", // 移动动画。默认为 null。例如 https://easings.net/。
                fallbackTolerance: 50, // 以像素为单位指定鼠标在被视为拖动之前应移动的距离
                swapThreshold: 50, // 交换区域的阈值
            });
        });
        // 地区拖动排序
        this.$nextTick(() => {
            let that = this;
            Sortable.create(document.getElementById('WishSortTable3'),{
                animation: 300,
                easing: "cubic-bezier(1, 0, 0, 1)", // 移动动画。默认为 null。例如 https://easings.net/。
                fallbackTolerance: 50, // 以像素为单位指定鼠标在被视为拖动之前应移动的距离
                swapThreshold: 50, // 交换区域的阈值
            });
        });
    },
    methods:{
        //获取批次
        GetRecommend(){
            let data = getStore('LoginData')
            if (!data) {
                this.$message.error('未登录！')
                return;
            }
            data = JSON.parse(data);
            if(!data.UserStudent){
                this.$confirm("基本信息未完善,是否前往完善？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('/userinfo');
                }).catch(() => {
                });
                return;
            }
            if(!data.UserStudent.UserScore){
                this.$confirm("高考成绩未完善,是否前往完善？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('/examinee');
                }).catch(() => {
                });
                return;
            }
            let user = data.UserStudent.UserScore;
            API.Recommend.GetRecommend({ProvinceId:user.ExamProvinceId,SubjectType:user.SubjectType,Score:(user.Score||user.FinalScore)}).then(res => {
                if (res.code == 0 &&res.data) {
                    this.BatchData = res.data.RecommendBatchList;
                }
                this.GetWishProvinceAll();// 地区
            });
        },
        //设置参数
        SetData(batchId){
            // 获取选中省份
            let province = getStore('OrgProvince')
            if (!province) {
                this.$message.error('未获取到省份数据！')
                return false
            }
            this.ProvinceObj = JSON.parse(province);
            let sww = this.ProvinceObj.WishWayDic[batchId];
            if(sww){
                if(sww.EducationLevel!==0 && sww.EducationLevel!==1) {
                    this.MajorScreenSelectLevel = 0;
                }
                else {
                    this.MajorScreenSelectLevel = sww.EducationLevel;
                }
            }
        },
        //批次切换
        BatchDataChange(batchId){
            this.SetData(batchId);//设置参数
            this.SubmitData.IntentionMajorList=[];
            this.MajorTypeCheckList=[];
            this.GetMajorTypeData();// 获取专业类别数据
        },
        // 地区
        GetWishProvinceAll(){
            API.Web.GetWishProvinceAll().then(res => {
                if (res.Code==0) {
                    this.AreaData = res.Data
                }
                this.GetUserIntentionDetail();//获取填报意向
            })
        },
        //获取填报意向
        GetUserIntentionDetail(){
            API.Personal.GetUserIntentionDetail().then(res => {
                if (res.Code==0&&res.Data) {
                    this.SubmitData = res.Data;
                    this.SubmitData.IntentionCollegeList.forEach(it1 => {
                        this.SearchCollegeCheckList.push({Id:it1.CollegeId,Name:it1.CollegeName});
                    });
                    this.SubmitData.IntentionMajorList.forEach(it2 => {
                        this.MajorTypeCheckList.push({Id:it2.MajorId,Name:it2.MajorName});
                    });
                    this.SubmitData.IntentionAreaList.forEach(it3 => {
                        this.AreaDataCheck.push({ProvinceId:it3.AreaId,ProvinceName:it3.AreaName});
                    });
                    this.SetData(this.SubmitData.IntentionBatchId);//设置参数
                    this.GetMajorTypeData();// 获取专业类别数据
                }
            })
        },
        // 搜索院校
        searchCollege() {
            if (!this.SearchCollegeName){
                this.$message.info('请输入院校');
                return;
            }
            API.Query.SearchCollegeByName({Name:this.SearchCollegeName}).then(res => {
                if (res.Code==0) {
                    this.SearchCollegeData = res.Data
                    this.ShowCollegeSearch = true
                }
            })
        },
        // 选择院校
        SelectSearchItem(item) {
            let tempIndex = this.SearchCollegeCheckList.findIndex(i => i.Id === item.Id)
            if (tempIndex !== -1) {
                this.SearchCollegeCheckList.splice(tempIndex, 1)
            }
            else {
                this.SearchCollegeCheckList.push(item)
            }
        },
        // 清空院校输入框
        clearCollegeSearch() {
            this.SearchCollegeData = []
            setTimeout(() => {
                this.ShowCollegeSearch = true;
            },100)
        },
        // 院校输入框获取光标
        focusCollegeSearch(){
            this.ShowCollegeSearch=true;
        },
        // 移除选中的院校
        RemoveCollegeItem(item){
            // this.SubmitData.IntentionCollegeList = this.SubmitData.IntentionCollegeList.filter(f=>f.CollegeId!==item.Id);
            this.SearchCollegeCheckList = this.SearchCollegeCheckList.filter(f=>f.Id!==item.Id);
        },

        // 专业学历层次切换
        selectMajorLevel(type){
            this.MajorScreenSelectLevel = type;
            this.GetMajorTypeData();// 获取专业类别数据
        },
        // 获取专业类别数据
        GetMajorTypeData() {
            API.Web.GetMajorTreeList({EducationLevel:this.MajorScreenSelectLevel}).then(res => {
                if(res.code==0){
                    this.MajorTypeData = res.data;
                    this.MajorCheckNumber();
                    this.$nextTick(()=>{
                        this.MajorCheckListStyle = 'height:350px';
                    });
                }
            })
        },
        // 绑定已选专业数量
        MajorCheckNumber(){
            this.MajorTypeData.forEach(item=>{
                let num=0;
                item.SubList.forEach(m=>{
                    if(this.MajorTypeCheckList.find(f=>f.Id==m.Id)){
                        num+=1;
                    }
                    if(m.SubList){
                        let thn=0;
                        m.SubList.forEach(t=>{
                            if(this.MajorTypeCheckList.find(f=>f.Id==t.Id)){
                                thn+=1;
                                num+=1;
                            }
                        });
                        m.CheckNumber = thn;
                    }
                });
                item.CheckNumber = num;
            });
        },
        // 专业类别选择
        MajorTypeCheck(item){
            let temp = this.MajorTypeCheckList.find(f => f.Id === item.Id);// 判断是否存在当前专业类
            if(temp){
                this.MajorTypeCheckList = this.MajorTypeCheckList.filter(f=>f.Id!=item.Id);// 移除dom选中的当前专业类
            }
            else{
                this.MajorTypeCheckList.push({Id: item.Id,Name: item.Name,EducationLevel:this.MajorScreenSelectLevel});// 添加dom选中的当前专业类
            }
            this.MajorCheckNumber();//更新已选专业数量
        },
        // 移除专业类别
        RemoveMajorItem(item){
            // this.SubmitData.IntentionMajorList = this.SubmitData.IntentionMajorList.filter(f=>f.MajorId!=item.Id);
            this.MajorTypeCheckList = this.MajorTypeCheckList.filter(f=>f.Id!==item.Id);
            this.MajorCheckNumber();//更新已选专业数量
        },
        // 三级专业显示
        ThreeMajorLayerShow(id,data){
            this.ThreeMajorShow = true;
            this.ThreeMajorData = data;
            this.MajorTypeHover = id;
        },
        // 三级专业隐藏
        ThreeMajorLayerHide(){
            this.ThreeMajorShow = false;
        },
        // 是否包含专业
        ContainMajorCheck(val){
            this.SubmitData.IsMajorAcceptOnly = val;
        },

        //移除地区
        RemoveAreaItem(item){
            this.SubmitData.IntentionAreaList=this.SubmitData.IntentionAreaList.filter(f=>f.AreaId!==item.ProvinceId);
            this.AreaDataCheck=this.AreaDataCheck.filter(f=>f.ProvinceId!==item.ProvinceId);
        },
        //选中地区
        AreaCheck(item){
            let obj = this.AreaDataCheck.find(f=>f.ProvinceId==item.ProvinceId);
            if(obj){
                this.AreaDataCheck=this.AreaDataCheck.filter(f=>f.ProvinceId!==item.ProvinceId);
            }
            else{
                this.AreaDataCheck.push(item);
            }
        },

        //提交填报意向
        SubmitIntention(){
            if(!this.SubmitData.IntentionBatchId){
                this.$message.info("请选择批次！");return;
            }
            this.loading = this.$loading({
                lock: false,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                color: '#000'
            });
            //批次处理
            this.SubmitData.IntentionBatchName='';
            if(this.SubmitData.IntentionBatchId){
                let obj = this.BatchData.find(f=>f.BatchId==this.SubmitData.IntentionBatchId);
                if(obj){
                    this.SubmitData.IntentionBatchName = obj.BatchName;
                }
            }
            //处理院校
            this.SubmitData.IntentionCollegeList=[];
            let data1 = document.getElementById("WishSortTable1").children;
            data1.forEach(it => {
                let o1 = this.SearchCollegeCheckList.find(f=>f.Id==it.id);
                if(o1){
                    this.SubmitData.IntentionCollegeList.push({AreaType:1,CollegeId:o1.Id,CollegeName:o1.Name});
                }
            });
            //处理专业
            this.SubmitData.IntentionMajorList=[];
            let data2 = document.getElementById("WishSortTable2").children;
            data2.forEach(it => {
                let o2= this.MajorTypeCheckList.find(f=>f.Id==it.id);
                if(o2){
                    this.SubmitData.IntentionMajorList.push({AreaType:1,MajorId:o2.Id,MajorName:o2.Name,EducationLevel:o2.EducationLevel});
                }
            });
            //处理地区
            this.SubmitData.IntentionAreaList=[];
            let data3 = document.getElementById("WishSortTable3").children;
            data3.forEach(it => {
                let o3= this.AreaDataCheck.find(f=>f.ProvinceId==it.id);
                if(o3){
                    this.SubmitData.IntentionAreaList.push({AreaType:1,AreaId:o3.ProvinceId,AreaName:o3.ProvinceName});
                }
            });

            API.Personal.SaveUserIntention(this.SubmitData).then(res=>{
              if(res.Code==0){
                this.$message.success("保存成功！");
              }
              else{
                this.$message.error(res.Message);
              }
              this.loading.close()
            });
        }
    }
}
</script>
<style scoped lang="less">
.intention_box{
    .userintente{
        border-radius: 5px;
        margin: 20px 20px 0;
        .userintentetitle{
            text-indent: 10px;
            line-height: 40px;
            height: 40px;
            color: #636262;
            font-size: 14px;
            background-color: #cfcfcf;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
        }
        .userintentebox{
            border: 1px solid #ddd;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            .uibox{
                border-top: 1px solid #ddd;
                position: relative;
                .uitip{
                    width: 100px;
                    float: left;
                    color: #666;
                    font-size: 14px;
                    text-align: right;
                    line-height:80px;
                }
                .mjitem{
                    padding-top: 20px;
                    width: calc(100% - 100px);
                    float: left;
                    .area{
                        display: inline-block;
                        color: #666;
                        font-size: 12px;
                        padding: 2px 18px;
                        border: 1px solid #e2e2e2;
                        border-radius: 20px;
                        margin: 0px 8px 10px;
                        transition: all 0.2s;
                        -webkit-transition: all 0.2s;
                        position: relative;
                        cursor: pointer;
                        user-select: none;
                    }
                    .area.on{
                        border: 1px solid rgba(var(--themecolor), 0.75);
                        background-color: rgba(var(--themecolor), 0.75);
                        color: #fff;
                    }
                }
                .uiitem{
                    width: calc(100% - 161px);
                    display: inline-block;
                    padding: 10px 10px;
                    margin-left: 120px;
                    border: 1px dashed #fff;
                    border-radius: 5px;
                    margin-bottom: 20px;
                    .nocheck{
                        color: #555;
                        font-size: 14px;
                    }
                    .it{
                        display: inline-block;
                        color: #555;
                        font-size: 14px;
                        overflow: hidden;
                        position: relative;
                        margin: 5px 0px 0px;
                        height: 20px;
                        line-height: 20px;
                        user-select: none;
                        margin-right: 10px;
                        border-radius: 20px;
                        border: 1px solid #ddd;
                        padding: 0 0px 0 10px;
                        .close{
                            display: inline-block;
                            width: 30px;
                            height: 100%;
                            text-align: center;
                            line-height: 20px;
                            &:hover{
                                color: rgba(var(--themecolor), 1);
                                cursor: pointer;
                            }
                        }
                    }
                }
                .levbox{
                    .item{
                        display: inline-block;
                        color: #666;
                        font-size: 12px;
                        padding: 2px 18px;
                        border: 1px solid #e2e2e2;
                        border-radius: 20px;
                        margin: 0px 8px 10px;
                        transition: all 0.2s;
                        -webkit-transition: all 0.2s;
                        position: relative;
                        i{
                            margin-left: 5px;
                            color: #999;
                        }
                    }
                    .item:hover{
                        border: 1px solid rgba(var(--themecolor),0.75);
                        cursor: pointer;
                        color: rgba(var(--themecolor),0.75);
                    }
                    .item.on{
                        border: 1px solid rgba(var(--themecolor),0.75);
                        background-color: rgba(var(--themecolor),0.75);
                        color: #fff;
                    }
                }
                .other{
                    padding-top: 20px;
                    width: calc(100% - 100px);
                    float: left;
                    padding-bottom: 20px;
                    .ot{
                        display: inline-block;
                        padding: 5px 20px;
                        color: #555;
                        font-size: 14px;
                        border-radius: 20px;
                        overflow: hidden;
                        position: relative;
                        margin: 5px 6px 0px;
                        height: 20px;
                        line-height: 20px;
                        user-select: none;
                        border: 1px solid #ddd;
                        border-radius: 20px;
                        &:hover{
                            border: 1px solid rgba(var(--themecolor), 0.75);
                        }
                    }
                }
                .chbox{
                    margin-left: 110px;
                    margin-top: 10px;
                    .check{
                        float: left;
                        color: #666;
                        font-size: 14px;
                        margin-right: 30px;
                        cursor: pointer;
                        line-height: 40px;
                        .ico{
                            border: 1px solid #cacaca;
                            border-radius: 20px;
                            background-color: #fff;
                            float: left;
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            margin-right: 5px;
                            margin-top: 10px;
                            i{
                                font-size: 13px;
                                color: rgba(var(--themecolor),1);
                                font-weight: bold;
                                display: none;
                            }
                        }
                        .ico.on{
                            border: 1px solid rgba(var(--themecolor),0.5);
                        }
                        .ico.on i{
                            display: inline-block;
                        }
                    }
                }
            }
            .sinputbox{
                width:calc(100% - 300px);
                height: 40px;
                position: relative;
                z-index: 8;
                margin: 20px 0 20px 20px;
                float: left;
                .search-box {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    z-index: 9;
                    width: 100%;
                    min-height: 100px;
                    max-height: 300px;
                    border: 1px solid #f0f0f0;
                    border-radius: 3px;
                    box-shadow: 0 0 10px #c3c3ed;
                    background-color: #fff;
                    font-size: 14px;

                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                        background-color: #f1f1f1;
                        border-radius: 5px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: #e7e7e7;
                        border-radius: 5px;
                    }
                    &::-webkit-scrollbar-thumb:hover {
                        background-color: #d5d4d4;
                    }

                    .search-li {
                        padding: 5px 20px 5px 50px;
                        cursor: pointer;
                        color: #616060;
                        font-size: 15px;
                        border-bottom: 1px solid #f3eeee;
                        position: relative;
                        line-height: 26px;
                        &:hover {
                            color: rgba(var(--themecolor),1);
                        }
                        .selected-icon {
                            position: absolute;
                            left: 20px;
                            color: rgba(var(--themecolor),1);
                        }
                    }
                    .no-data {
                        padding-top: 40px;
                        text-align: center;
                        color: #999;
                    }
                    .DisableSelect {
                        color: #999;
                        &:hover {
                            cursor: not-allowed;
                            color: #999;
                        }
                    }
                }
            }
            .s_btn{
                width: 150px;
                display: inline-block;
                height: 38px;
                margin-left: 10px;
                text-align: center;
                background-color: rgba(var(--themecolor),0.8);
                border-radius: 5px;
                color: #fff;
                font-size: 14px;
                letter-spacing: 1px;
                line-height: 38px;
                position: relative;
                z-index: 50;
                margin-top: 20px;
            }
            .s_btn:hover{
                cursor: pointer;
                background-color: rgba(var(--themecolor),1);
            }
        }
    }
    .submitbtn{
        width: 200px;
        height: 42px;
        margin-left: 10px;
        text-align: center;
        background-color: rgba(var(--themecolor),0.8);
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 42px;
        margin: 30px auto;
        font-weight: bold;
        &:hover{
            cursor: pointer;
            background-color: rgba(var(--themecolor),1);
        }
    }
}
.search_majorbox{
    overflow: hidden;
    z-index: 2;
    padding: 10px 0 10px;
    user-select: none;
    position: relative;
    .citem{
        color: #666;
        font-size: 12px;
        padding: 2px 40px 2px 45px;
        border-radius: 20px;
        margin: 0px 0px 10px;
        transition: all 0.2s;
        -webkit-transition: all 0.2s;
        position: relative;
        .chck{
            width: 16px;
            height: 16px;
            border: 1px solid #e2e2e2;
            border-radius: 16px;
            font-size: 12px;
            color: #fff;
            background-color: #fff;
            position: absolute;
            left: 20px;
            top: 3px;
            z-index: 1;
            text-align: center;
            line-height: 16px;
        }
        .mname{
            position: relative;
            padding-top: 1px;
            display: inline-block;
            .num{
                position: absolute;
                right: -12px;
                top: -5px;
                background-color: rgba(var(--themecolor), 0.75);
                color: #fff;
                font-size: 9px;
                width: 12px;
                height: 12px;
                border-radius: 12px;
                line-height: 12px;
                text-align: center;
                overflow: hidden;
            }
        }
        .mname.on{
            color: rgba(var(--themecolor), 1);
        }
        .three{
            position: absolute;
            right: 10px;
            top: 0;
            z-index: 1;
            width: 30px;
            height: 100%;
            text-align: center;
            line-height: 20px;
            font-size: 14px;
        }
    }
    .citem:hover{
        cursor: pointer;
        color: rgba(var(--themecolor),0.75);
    }
    .citem.on{
        color: rgba(var(--themecolor),9);
        .chck{
            border: 1px solid rgba(var(--themecolor),1);
            color: rgba(var(--themecolor),1);
        }
        .three{
            color: #666;
        }
    }
    .three_major_box{
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0px;
        right: 0px;
        z-index: 3;
        background-color: #fff;
        border-left: 1px solid #ddd;
        padding-top: 10px;
        .citem{
            padding-right: 10px;
        }
    }
}
</style>
<style lang="less">
.intention_box .userintente .uibox .mjbox .el-button{
    padding:3px 10px 3px 18px;
    margin: 0px 8px 10px;
    border-radius: 20px;
    color: #666;
    font-size: 12px;
    position: relative;
    i{
        color: #999;
        font-size: 12px;
        margin-left: 3px;
    }
    .num{
        position: absolute;
        right: -7px;
        top: -8px;
        z-index: 2;
        font-size: 8.5px;
        background-color: rgba(var(--themecolor), 0.75);
        color: #fff;
        width: 12px;
        height: 12px;
        border-radius: 12px;
        line-height: 12px;
        text-align: center;
        overflow: hidden;
    }
}
.intention_box .userintente .uibox .mjbox .el-button:hover{
    border-color: rgba(var(--themecolor),0.8);
    background-color: #fff;
    color: rgba(var(--themecolor),0.8);
}
.intention_box .userintente .uibox .mjbox .el-button:focus{
    border: 1px solid #DCDFE6;
}
.search_majorbox .el-scrollbar__wrap{
    overflow-x: hidden;
}
.intention_box .userintente .uibox .el-switch__label.el-switch__label--left.is-active{
    color: rgba(var(--themecolor), 1);
}
.intention_box .userintente .uibox .el-switch__label.el-switch__label--right.is-active{
    color: rgb(7, 180, 85);
}
.intention_box .userintente .uibox .el-switch.is-checked .el-switch__core{
    border-color: #929292;
    background-color: #929292;
}
</style>